import { render, staticRenderFns } from "./admin-search-redchirp-numbers.vue?vue&type=template&id=aa3a6bb2&scoped=true&"
import script from "./admin-search-redchirp-numbers.vue?vue&type=script&lang=js&"
export * from "./admin-search-redchirp-numbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3a6bb2",
  null
  
)

export default component.exports